module.exports = __webpack_public_path__ + "img/fashion-apparel.353bb952.webp";